import { render, staticRenderFns } from "./LiteracyAssessmentDetails.vue?vue&type=template&id=59736cb0&scoped=true"
import script from "./LiteracyAssessmentDetails.vue?vue&type=script&lang=js"
export * from "./LiteracyAssessmentDetails.vue?vue&type=script&lang=js"
import style0 from "./LiteracyAssessmentDetails.vue?vue&type=style&index=0&id=59736cb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59736cb0",
  null
  
)

export default component.exports